import axios from "axios";
import { getApiBaseUrl } from "../utils/apiBaseUrl";

export interface PamLocationData {
  stateName: string | null;
  districtName: string | null;
  postOfficeName: string | null;
  pincode: number;
  blockCode: string;
  addressCode: string;
  pamCode: string;
}

export interface SearchPamCodesResponse {
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  data: PamLocationData[];
}

export const SearchPamCodesByLocationAsync = async (
  stateName: string = "",
  districtName: string = "",
  postOfficeName: string = "",
  pageNumber: number = 1,
  pageSize: number = 10,
  token: string
): Promise<SearchPamCodesResponse> => {
  const baseUrl = getApiBaseUrl();

  try {
    const response = await axios.get<SearchPamCodesResponse>(
      `${baseUrl}/api/Admin/SearchPamCodesByLocationAsync`,
      {
        params: {
          stateName,
          districtName,
          postOfficeName,
          pageNumber,
          pageSize,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error searching PAM codes by location:",
      error
    );
    throw error;
  }
};